<template>
  <div class="relative flex-container d-flex flex-column ai-center">
    <div
      class="section-wrapper d-flex flex-column"
      v-bind:class="{ 'mg-150': !isMobile, 'mg-50': isMobile }"
    >
      <div class="header-2">History</div>
      <div
        class="flex-container d-flex flex-column"
        v-bind:class="{ 'mg-100': !isMobile, 'mg-50': isMobile }"
      >
        <ApolloQuery :query="require('../graphql/GetPublishedHistories.gql')">
          <template slot-scope="{ result: { data }, isLoading }">
            <div v-if="isLoading" class="flex-container center">
              <v-progress-circular color="#1c1c1c" indeterminate />
            </div>
            <template v-else>
              <div
                class="flex-container"
                v-for="(item, i) in parseYear(data)"
                :key="i"
              >
                <div class="year-slot text-2">{{ item[0] }}</div>
                <div class="month-slot">
                  <div
                    class="month-cell"
                    v-for="(month, midx) in parseMonth(item[1])"
                    :key="`mth${midx}`"
                  >
                    <div class="text-2 month bold ma-1">
                      {{ getMonthString(month[0]) }}
                    </div>
                    <div class="flex-container d-flex flex-column">
                      <div
                        class="text-2 ma-1"
                        v-for="(content, cidx) in month[1]"
                        :key="`ctx${midx}-${cidx}`"
                      >
                        {{ content.body }}
                      </div>
                    </div>
                  </div>
                  <div class="month-slot month-spacer" />
                </div>
              </div>
            </template>
          </template>
        </ApolloQuery>
      </div>
      <div v-if="!isMobile" class="mg-150" />
      <div v-if="isMobile" class="mg-50" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  methods: {
    parseYear(data) {
      const ok = data.GetPublishedHistories.ok;
      if (!ok) {
        alert("서버 에러");
        return [];
      }

      const rawHistories = data.GetPublishedHistories.histories;
      const map = new Map();

      for (const history of rawHistories) {
        const collection = map.get(history.year);
        if (collection) {
          collection.push(history);
          collection.sort((a, b) => b.month - a.month);
        } else {
          map.set(history.year, [history]);
        }
      }

      const arr = [...map.entries()];

      return arr.sort((a, b) => b[0] - a[0]);
    },
    parseMonth(data) {
      const map = new Map();

      for (const history of data) {
        const collection = map.get(history.month);
        if (collection) {
          collection.push(history);
        } else {
          map.set(history.month, [history]);
        }
      }

      const arr = [...map.entries()];

      return arr.sort((a, b) => b[0] - a[0]);
    },
    getMonthString(month) {
      if (month < 10) {
        return `0${month}.`;
      } else {
        return `${month}.`;
      }
    },
  },
};
</script>

<style scoped>
.year-slot {
  padding: 10px;
  height: 34px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px solid black;
  z-index: 2;
}

.month-slot {
  border-left: 1px solid lightgrey;
  margin-left: -1px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.month-cell {
  padding: 5px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.month {
  width: 20px;
}

.month-spacer {
  height: 10px;
  width: 100%;
}
</style>
